module.exports = __webpack_public_path__ + "img/upweixin.fb638d9d.png";